import useMediaQuery from '@utilities/hooks/useMediaQuery'

const useIsDesktop = () => {
  return useMediaQuery(`(min-width: 768px)`)
}

export default useIsDesktop
